import React, { useState, useRef, useEffect } from "react";

type Message = {
  sender: "user" | "ai";
  text: string;
};

const AiChatbot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState<Message[]>([
    { sender: "ai", text: "Hello! Welcome to Mediit Academy. Main aapki kya madad kar sakta hu?" }
  ]);
  const [input, setInput] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const messagesEndRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const sendMessage = async () => {
    if (!input.trim()) return;

    const userMsg = input.trim();
    
    // Naya message list me add karo
    const updatedMessages = [...messages, { sender: "user" as const, text: userMsg }];
    setMessages(updatedMessages);
    setInput("");
    setIsLoading(true);

    // LocalStorage se logged-in student ka naam nikalna
    const studentName = localStorage.getItem("studentName") || localStorage.getItem("name") || "";

    try {
      // const response = await fetch("http://localhost:9092/api/ai-chat", {
      const response = await fetch("https://py-api.mediitacademy.com/api/ai-chat", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ 
          message: userMsg,
          history: messages, // Purani chat bhej rahe hain (Context ke liye)
          user_name: studentName // Student ka naam bhej rahe hain
        }),
      });

      const data = await response.json();
      
      setMessages((prev) => [
        ...prev,
        { sender: "ai", text: data.reply || data.error || "Kuch error aa gaya hai." },
      ]);
    } catch (error) {
      setMessages((prev) => [
        ...prev,
        { sender: "ai", text: "Server se connect nahi ho paaya. Please check if Python server is running." },
      ]);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="fixed bottom-6 right-6 z-50">
      {isOpen && (
        <div className="mb-4 flex h-[480px] w-[360px] flex-col overflow-hidden rounded-[24px] bg-white shadow-2xl border border-slate-200">
          <div className="bg-gradient-to-r from-blue-600 to-cyan-500 p-4 text-white flex justify-between items-center">
            <div className="flex items-center gap-2">
              <span className="text-2xl">🤖</span>
              <div>
                <h3 className="font-black text-sm">Mediit AI Support</h3>
                <p className="text-[10px] font-bold opacity-80">Smart Assistant</p>
              </div>
            </div>
            <button onClick={() => setIsOpen(false)} className="text-xl font-bold hover:text-red-200">×</button>
          </div>

          <div className="flex-1 overflow-y-auto p-4 bg-[#f8fbff] space-y-4">
            {messages.map((msg, idx) => (
              <div key={idx} className={`flex ${msg.sender === "user" ? "justify-end" : "justify-start"}`}>
                <div className={`max-w-[85%] rounded-2xl px-4 py-2.5 text-sm font-semibold whitespace-pre-wrap ${
                  msg.sender === "user" 
                    ? "bg-blue-600 text-white rounded-br-sm" 
                    : "bg-white border border-slate-200 text-slate-800 rounded-bl-sm leading-relaxed"
                }`}>
                  {msg.text}
                </div>
              </div>
            ))}
            {isLoading && (
              <div className="flex justify-start">
                <div className="bg-white border border-slate-200 text-slate-400 rounded-2xl rounded-bl-sm px-4 py-2 text-sm font-bold">
                  Typing...
                </div>
              </div>
            )}
            <div ref={messagesEndRef} />
          </div>

          <div className="p-3 bg-white border-t border-slate-100 flex gap-2">
            <input
              type="text"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && sendMessage()}
              placeholder="Ask anything..."
              className="flex-1 rounded-xl bg-slate-50 px-4 py-2.5 text-sm font-bold text-slate-800 outline-none border border-slate-200 focus:border-blue-500"
            />
            <button 
              onClick={sendMessage}
              disabled={isLoading}
              className="bg-blue-600 hover:bg-blue-700 text-white rounded-xl px-4 font-black transition disabled:opacity-50"
            >
              ➤
            </button>
          </div>
        </div>
      )}

      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex h-14 w-14 items-center justify-center rounded-full bg-blue-600 text-2xl text-white shadow-lg shadow-blue-600/30 hover:scale-110 transition-transform"
      >
        {isOpen ? "×" : "💬"}
      </button>
    </div>
  );
};

export default AiChatbot;